export default function () {

    const $scrollButton = $('.js-bod-hero-scroll');
    const $scrollToSection = $('.js-bod-hero-next-section');
    const $header = $('.bod-app-header');

    $scrollButton.on('click', (el) => {
        const target = $(el.target).attr('href');
        if (target.includes('#bod-hero-next-section')) {
            el.preventDefault();
            const elementOffset = $scrollToSection.offset();
            const headerHeight = $header.outerHeight();
            const targetOffset = elementOffset.top - headerHeight;

            $('html, body').animate({
                scrollTop: targetOffset + 1
            }, 1000);
        }

    });

}



// WEBPACK FOOTER //
// ../Resources/Private/JavaScript/features/heroscroll.js